module.exports = __webpack_public_path__ + "static/img/AlexVolkanovski.3476f3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AlexVolkanovski.jpg
// module id = hqOK
// module chunks = 0